import { useState } from "react";
import { UploadZone } from "../UploadZone";
import { DocumentList } from "../DocumentList";
import { StatCards } from "../StatCards";
import { DemoButton } from "../DemoButton";
import { EligibilityOverview } from "../EligibilityOverview";
import { AlertsPanel } from "../AlertsPanel";
import { CompliancePanel } from "../CompliancePanel";
import RecommendedAddon from "../RecommendedAddon";

const FILTERS = [
  { key: "all", label: "All" },
  { key: "pending", label: "Pending review" },
  { key: "high", label: "High risk" },
  { key: "verified", label: "Verified" },
];

export default function AgencyDashboard({ user, documents, stats, refresh, docTotal, loadMore }) {
  const [filter, setFilter] = useState("all");

  const filtered = documents.filter((d) => {
    if (filter === "pending") return d.review_status === "pending" && d.status === "analyzed";
    if (filter === "high") return d.risk_level === "high";
    if (filter === "verified") return d.review_status === "verified";
    return true;
  });

  return (
    <div data-testid="agency-dashboard" className="space-y-10">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#C07A60]">Agency Portal</p>
          <h1 className="mt-2 text-3xl md:text-4xl font-heading font-light tracking-tight">
            Review queue, <span className="font-bold text-[#2E5C50]">{user.name}</span>
          </h1>
          <p className="mt-2 text-[#57605A]">
            Review family submissions, verify compliance, and resolve flags before they become denials.
          </p>
        </div>
        <DemoButton onSeeded={refresh} />
      </div>

      <StatCards stats={stats} />

      <RecommendedAddon />

      <CompliancePanel />

      <AlertsPanel />

      <EligibilityOverview />

      <div className="grid lg:grid-cols-5 gap-8">
        <div className="lg:col-span-2">
          <h2 className="text-lg font-heading font-semibold mb-4">Upload a document</h2>
          <UploadZone onUploaded={refresh} />
        </div>
        <div className="lg:col-span-3" data-testid="document-flags-overview">
          <div className="flex items-center justify-between mb-4 flex-wrap gap-3">
            <h2 className="text-lg font-heading font-semibold">All documents</h2>
            <div className="flex gap-1.5 flex-wrap">
              {FILTERS.map((f) => (
                <button
                  key={f.key}
                  data-testid={`filter-${f.key}`}
                  onClick={() => setFilter(f.key)}
                  className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-colors duration-200 ${
                    filter === f.key
                      ? "bg-[#2E5C50] text-white"
                      : "bg-white border border-[#E8E6E1] text-[#57605A] hover:border-[#2E5C50]"
                  }`}
                >
                  {f.label}
                </button>
              ))}
            </div>
          </div>
          <DocumentList documents={filtered} showUploader total={filter === "all" ? docTotal : 0} onLoadMore={loadMore} />
        </div>
      </div>
    </div>
  );
}
